import { useTranslation } from 'react-i18next';
import { ScreenCepActivitiesConfig } from './MiViewScreenCepActivities.types';

const useScreenCepActivitiesConfig = (
  collapseAllAction: Function,
  expandAllAction: Function,
  fullScreenAction: Function,
  minimizeScreenAction: Function,
  fullScreen: boolean,
) => {
  const { t } = useTranslation();

  const screenCepTargetsConfig: ScreenCepActivitiesConfig = {
    menuList: [
      {
        label: t('maya_miview_menu_action_collapse_all'),
        clickAction: collapseAllAction,
      },
      {
        label: t('maya_miview_menu_action_expand_all'),
        clickAction: expandAllAction,
      },
      fullScreen
        ? {
          label: t('maya_miview_menu_action_minimize_screen'),
          clickAction: minimizeScreenAction,
        }
        : {
          label: t('maya_miview_menu_action_fullscreen'),
          clickAction: fullScreenAction,
        },
    ],
  };

  return { screenCepTargetsConfig };
};

export default useScreenCepActivitiesConfig;
